class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Sur desktop (min-width: 990px), ouvrir au hover au lieu du clic
    if (window.innerWidth >= 990) {
      this.enableHoverBehavior();
    }

    // Réactiver le hover après un resize
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        this.enableHoverBehavior();
      } else {
        this.disableHoverBehavior();
      }
    });
  }

  enableHoverBehavior() {
    // Ouvrir au mouseenter
    this.addEventListener('mouseenter', () => {
      this.mainDetailsToggle.setAttribute('open', '');
    });

    // Fermer au mouseleave
    this.addEventListener('mouseleave', () => {
      this.mainDetailsToggle.removeAttribute('open');
    });

    // Empêcher le toggle au clic sur desktop
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) {
          e.preventDefault();
        }
      });
    }
  }

  disableHoverBehavior() {
    // Sur mobile, utiliser le comportement par défaut (clic)
    // Les event listeners de hover resteront mais ne seront pas gênants
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
